import React from 'react';
import styles from '../../styles/onlineCounselling.module.scss';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CustomImage from '../CustomImage';
import { useRouter } from 'next/router';
import useZipmeLink from '../../hooks/useZipmeLink';
import { isFrappeOrJotFormClass } from '../../utils/helpers';
interface Props {
    studyabrdata: any;
    jotformId: any;
    slug: string;
    externalLink: any;
}

const Studyabroadjourney: React.FC<Props> = ({ studyabrdata, jotformId, slug, externalLink }) => {
    const buttonLabel = slug === "nagpur" ? "Enquire Now" : "Book Free Online Counselling";
    const router = useRouter();
    const { zipmeLink, generateLink } = useZipmeLink();
    return (
        <div id="study_abroadjourney" className={styles.studywithScholarship} style={{ backgroundColor: studyabrdata?.sectionBgColor || "#fff" }} >
            <Container>
                <Row>
                    <div className={styles.heading}>
                        <h2>{studyabrdata?.sectionTitle}</h2>
                    </div>
                </Row>
                <Row>
                    <Col xl={4} lg={4} md={4} sm={12}>
                        <div className={styles.stuImg}>
                            <CustomImage src={studyabrdata?.sectionImageUrl || "/images/gilrwithpassport.png"} width={518} height={429} alt="EdTech1" />
                        </div>
                    </Col>
                    <Col xl={8} lg={8} md={8} sm={12}>
                        <div className={styles.OffersContent}>
                            <div className={styles.ulItem}>
                                {
                                    studyabrdata?.sectionPoints?.length > 0 &&
                                    studyabrdata.sectionPoints.map((studyabroaddata: string, ind: number) => {
                                        return (
                                            <p key={ind}>{studyabroaddata}</p>
                                        )
                                    })
                                }
                            </div>
                            <div className={styles.anchor}>
                                <a onClick={() => {
                                        !jotformId && generateLink(externalLink)
                                       }}
                                        className={`${styles.btnReg}${jotformId
                                            ? ` ${isFrappeOrJotFormClass(jotformId)}`
                                            : ''
                                            }`}
                                    >
                                    {buttonLabel}
                                </a>
                            </div>
                        </div>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Studyabroadjourney;